import { SERVICE_OGP_IMAGE, SITE_URL } from '../../constants'
import { buildServiceSchema } from '../../builders/service'
import { PageMeta } from '../../types'

const description = "構想からUX/UIデザイン・開発・運用まで、ワンチームで伴走するスマホアプリ開発。Swift・Kotlin・Flutterなどモダン技術とクラウドネイティブアーキテクチャで、リリース後も伸び続けるアプリを設計します。金融・不動産・人材など多業界での実績多数。"

export const applicationDevelopmentPageMeta: PageMeta = {
  title: "UX起点のスマホアプリ開発 | クラウドネイティブ×アジャイル | Aitria（アイトリア）",
  description,
  keyword: "アプリケーション アプリ 開発 クラウドネイティブ アジャイル iPhone android web ネイティブ",
  image: SERVICE_OGP_IMAGE,
  url: `${SITE_URL}/services/studio/application-development/`,
}

export const applicationDevelopmentSchema = buildServiceSchema({
  slug: "studio/application-development",
  name: "アプリケーション開発",
  description: applicationDevelopmentPageMeta.description,
  serviceType: "アプリケーション開発",
  category: "STUDIO",
  offerCatalogName: "アプリケーション開発サービス",
  breadcrumbName: "アプリケーション開発",
  offers: [
    {
      name: "既存システム・アプリのリニューアル",
      description: "使いにくさから現場に定着しない、開発後の運用・改善が続かない、など既存システムの課題を、OOUI（オブジェクト指向UI）を取り入れた設計で解決し、ユーザー満足度やエンゲージメントの向上を実現します。",
    },
    {
      name: "新規システム・アプリの開発",
      description: "要件定義に時間がかかりすぎて市場が変化してしまう、セキュリティ要件が厳しくAI活用が進まない、スピードと品質の両立ができないという課題を持つ企業に大して、AI駆動開発とUX/UI、エンタープライズ基準のセキュリティ対応を強みにデザインから開発まで一気通貫で支援します。",
    }
  ],
})
